import { ref, computed } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'

export default function useVerticalNavMenu(props) {
  // ------------------------------------------------
  // isVerticalMenuCollapsed
  // ------------------------------------------------
  const isVerticalMenuCollapsed = computed({
    get: () => store.state.verticalMenu.isVerticalMenuCollapsed,
    set: val => {
      store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', val)
    },
  })

  // ------------------------------------------------
  // collapseTogglerIcon
  // ------------------------------------------------
  const collapseTogglerIcon = computed(() => {
    if (props.isVerticalMenuActive) {
      return isVerticalMenuCollapsed.value ? 'unpinned' : 'pinned'
    }
    return 'close'
  })

  const isMouseHovered = ref(false)

  const updateMouseHovered = val => {
    isMouseHovered.value = val
  }

  const toggleCollapsed = () => {
    isVerticalMenuCollapsed.value = !isVerticalMenuCollapsed.value
  }

  const defaultPragram = computed({
    get: () => store.getters['verticalMenu/getDefaultProgram'],
    set: val => {
      store.commit('verticalMenu/UPDATE_DEFAULT_PROGRAM', val)
      router.push({ query: { program_id: val } })
    },
  })

  const programOptions = computed(() => store.getters['verticalMenu/getProgramOptions'])

  return {
    isMouseHovered,
    isVerticalMenuCollapsed,
    collapseTogglerIcon,
    toggleCollapsed,
    updateMouseHovered,
    defaultPragram,
    programOptions,
  }
}
